<template>
  <!-- dialog add docs -->
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'750px'"
    :classDialog="'thu-hoi-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    :appendToBody="true"
  >
    <template #body>
      <h3 class="dialogTitle">Thu hồi văn bản đến</h3>
      <div class="margin-bottom-10">
        <el-table
          ref="multipleTable"
          :data="nextVbIncomingProcesses"
          size="mini"
          stripe
          style="width: 100%"
          max-height="300"
          @selection-change="docSelectionChange"
        >
          <el-table-column type="selection" width="60"></el-table-column>
          <el-table-column
            label="Người/Đơn vị được chuyển "
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.receiverName"
                @click="itemClicked(scope.row)"
              >{{ scope.row.receiverName }} ({{
                  scope.row.roleReceiverName
                }})</span
              >
              <span v-else @click="itemClicked(scope.row)">{{
                  scope.row.deptReceiverName
                }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Thời gian chuyển"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span @click="itemClicked(scope.row)">{{
                  scope.row.updateTime | dateFormatter
                }}</span>
            </template>
          </el-table-column>
          <el-table-column
            property="docDate"
            label="Hình thức xử lý"
            width="125"
          >
            <template slot-scope="scope">
              <div class="flex-row flex__left" @click="itemClicked(scope.row)">
                <!-- <div class="theDueDate lv1 margin-right-10"></div> -->
                <p>{{ getProcessTypeLabel(scope.row.processType) }}</p>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-form  v-if="isNotVinatabatradingAndLanhDao()" :model="form" :rules="rules" ref="form" label-position="left">
          <el-form-item  label="Lý do thu hồi" prop="comment">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="-"
              v-model="form.comment"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <el-form  v-if="!isNotVinatabatradingAndLanhDao()" :model="form"  ref="form" label-position="left">
          <el-form-item  label="Lý do thu hồi" prop="comment">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="-"
              v-model="form.comment"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button
          type="success"
          size="mini"
          class="addDocs color__white btn-none__border"
          @click="submit"
        >
          <i class="fal fa-check"></i>&nbsp; Xác nhận
        </el-button>
        <el-button
          type="info"
          size="mini"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >
          <i class="fas fa-times"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>
import vbIncomingProcessService from "../../../services/vbIncomingProcessService";
import dateFormatter from "../../../filters/dateFormatter";
import constants from "../../../constants";
import h from "../../../services/h";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import {EventBus} from "../../../event-bus";

  export default {
    name: "thu-hoi-vb-den-dialog",
    filters: {dateFormatter},
    props: ["isOpen", "vbIncomingProcessId"],
    mixins: [handleRequestErrorMixin],
    components: {
      dialogTemplate: () => import("../../common/custom-dialog.vue")
    },
    data() {
      return {
        selectedVbIncomingProcesses: [],
        form: {comment: null},
        nextVbIncomingProcesses: [],
        rules: {
          comment: [
            {
              required: this.isNotVinatabatradingAndLanhDao(),
              message: "Trường dữ liệu bắt buộc",
              trigger: "blur"
            }
          ]
        }
      };
    },

  created() {
    this.loadNextVbIncomingProcesses();
  },

  computed: {
    tenantCode() {
      return this.$store.getters.userDeptRole.tenantCode;
    },

    roleCode() {
      return this.$store.getters.userDeptRole.roleCode;
    },
  },

  methods: {
    handleRequestError(error) {
      switch (error.errorCode) {
        case "vbIncomingProcess.thuHoi.nextVbIncomingProcessStatusMissMatch":
          let vbIncomingProcessId = error.params[0];
          let vbIncomingProcess = h.find(
            this.selectedVbIncomingProcesses,
            process => process.id === vbIncomingProcessId
          );
          let receiverName =
            vbIncomingProcess.stepType === constants.STEP.STEP_TYPE.CANHAN
              ? vbIncomingProcess.receiverName
              : vbIncomingProcess.deptReceiverName;
          this.$message({
            message: errorMessageFilter({
              errorCode: error.errorCode,
              params: [receiverName]
            }),
            type: "error"
          });
          break;
        default:
          this.$message({message: errorMessageFilter(error), type: "error"});
      }
      return true;
    },

    isNotVinatabatradingAndLanhDao(){
      return this.tenantCode !== "vinatabatrading.com.vn" ||
        (this.tenantCode === "vinatabatrading.com.vn" && this.roleCode !== "lanhdao")
        ;
    },

    docSelectionChange(val) {
      this.selectedVbIncomingProcesses = val;
    },

    submit() {
      if(this.isNotVinatabatradingAndLanhDao() || (!this.isNotVinatabatradingAndLanhDao() && this.form.comment !== null)){
        this.$refs.form.validate(valid => {
          if (!valid || !this.validateSelectedVbIncomingProcesses()) return;
          this.confirmPauseTask().then(isPauseTask => {
            let nextVbIncomingProcessIds = h.collect(
              this.selectedVbIncomingProcesses,
              item => item.id
            );
            vbIncomingProcessService
              .thuHoi(
                {
                  nextVbIncomingProcessIds: nextVbIncomingProcessIds,
                  comment: this.form.comment,
                  isPauseTask: isPauseTask
                },
                this.vbIncomingProcessId
              )
              .then(response => {
                this.$message({
                  message: "Thu hồi văn bản thành công",
                  type: "success"
                });
                EventBus.$emit('loadCounting', '');
                this.$emit("success", {vbIncomingProcess: response.data});
              })
              .catch(error => this.commonHandleRequestError(error));
          });
        });
      }
      else {
        this.$refs.form.validate(valid => {
          if (!valid || !this.validateSelectedVbIncomingProcesses()) return;
          this.confirmPauseTask().then(isPauseTask => {
            let nextVbIncomingProcessIds = h.collect(
              this.selectedVbIncomingProcesses,
              item => item.id
            );
            vbIncomingProcessService
              .thuHoi(
                {
                  nextVbIncomingProcessIds: nextVbIncomingProcessIds,
                  comment: "",
                  isPauseTask: isPauseTask
                },
                this.vbIncomingProcessId
              )
              .then(response => {
                this.$message({
                  message: "Thu hồi văn bản thành công",
                  type: "success"
                });
                EventBus.$emit('loadCounting', '');
                this.$emit("success", {vbIncomingProcess: response.data});
              })
              .catch(error => this.commonHandleRequestError(error));
          });
        });
      }
    },

    validateSelectedVbIncomingProcesses() {
      if (
        !this.selectedVbIncomingProcesses ||
        !this.selectedVbIncomingProcesses.length
      ) {
        this.notify("Lỗi", "Danh sách thu hồi bắt buộc chọn", "error", 2000);
        return false;
      }
      return true;
    },

    itemClicked(item) {
      this.$refs.multipleTable.toggleRowSelection(item);
    },

    loadNextVbIncomingProcesses() {
      return vbIncomingProcessService
        .findAll(
          {parentId: this.vbIncomingProcessId},
          {page: 0, size: 1000, order: "updateTime,desc"}
        )
        .then(response => (this.nextVbIncomingProcesses = response.data));
    },

    confirmPauseTask() {
      let isAutoAssignTask = h.exists(
        this.selectedVbIncomingProcesses,
        process => process.isAutoAssignTask === constants.TRUE
      );
      return !isAutoAssignTask
        ? Promise.resolve(true)
        : new Promise(resolve => {
          this.$confirm(
            `Đã có công việc được giao theo văn bản, bạn có muốn tạm dừng các công việc này ?`,
            "Thông báo",
            {
              confirmButtonText: "Xác nhận",
              cancelButtonText: "Hủy bỏ",
              type: "warning"
            }
          )
            .then(() => resolve(true))
            .catch(() => resolve(false));
        });
    },

    getProcessTypeLabel(processType) {
      switch (processType) {
        case constants.PROCESS_TYPE.CHUTRI:
          return "Chủ trì";
        case constants.PROCESS_TYPE.NHANDEBIET:
          return "Nhận để biết";
        case constants.PROCESS_TYPE.PHOIHOP:
          return "Phối hợp";
        default:
          return "-";
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/components/thuHoiDialog.vue